import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { RoleComponent } from './role/role.component';
import { RolesManagementComponent } from './roles-management.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        RoleComponent,
        RolesManagementComponent
    ],
    entryComponents: [RolesManagementComponent],
    exports: [RolesManagementComponent]
})
export class RolesManagementModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/roles-management/roles-management.module.ts